import { defineMessages } from 'react-intl';

export const LocationStepContent = defineMessages({
  scanSuccess: {
    id: 'app.common.scanSuccess',
    defaultMessage: 'QR kód úspěšně naskenován',
  },
  meterPhotoContext: {
    id: 'app.common.meterPhotoContext',
    defaultMessage: 'Fotky okolí',
  },
  meterPhotoContextHelp: {
    id: 'app.common.meterPhotoContextHelp',
    defaultMessage:
      'Vyfoť měřidlo z větší dálky spolu s jeho okolím tak abychom se mohli nachystat na osazení a nic nás nepřekvapilo.',
  },
  meterPhotoContextRequired: {
    id: 'app.common.meterPhotoContextRequired',
    defaultMessage: 'Musíš nahrát alespoň jednu fotku okolí měřidla!',
  },
  newMeter: {
    id: 'app.common.newMeter',
    defaultMessage: 'Nové měřidlo',
  },
  newMeterRequired: {
    id: 'app.common.newMeterRequired',
    defaultMessage: 'Musíš nahrát, zda jde o existující měřidlo!',
  },
  newMeterTooltip: {
    id: 'app.common.newMeterTooltip',
    defaultMessage:
      'Vyber zda jde o existující měřidlo nebo se jedná o návrh nového měření a mělo by dojít k jeho instalaci.',
  },
  existingMeter: {
    id: 'app.common.existingMeter',
    defaultMessage: 'Stávající měřidlo',
  },
  newMeterDraft: {
    id: 'app.common.newMeterDraft',
    defaultMessage: 'Návrh nového měření',
  },
  selectValid: {
    id: 'app.common.selectValid',
    defaultMessage: 'Vyber platné',
  },
  commodity: {
    id: 'app.common.commodity',
  },
  commodityRequired: {
    id: 'app.common.commodityRequired',
  },
  submeter: {
    id: 'app.common.submeter',
    defaultMessage: 'Podružné měřidlo',
  },
  submeterRequired: {
    id: 'app.common.submeterRequired',
    defaultMessage: 'Třeba vybrat hlavní, nebo podružné měřidlo!',
  },
  submeterTooltip: {
    id: 'app.common.submeterTooltip',
    defaultMessage: 'Vyber v závislosti na tom, jestli se jedná o hlavní nebo podružné měřidlo.',
  },
  main: {
    id: 'app.common.main',
    defaultMessage: 'Hlavní',
  },
  secondary: {
    id: 'app.common.secondary',
    defaultMessage: 'Podružný',
  },
  monitoredEntity: {
    id: 'app.common.monitoredEntity',
    defaultMessage: 'Název měřidla',
  },
  monitoredEntityRequired: {
    id: 'app.common.monitoredEntityRequired',
    defaultMessage: 'Třeba poznamenat, co měřidlo měří!',
  },
  monitoredEntityPlaceholder: {
    id: 'app.common.monitoredEntityPlaceholder',
    defaultMessage: 'světla, hala, dopouštění SHZ atd.',
  },
  building: {
    id: 'app.common.building',
    defaultMessage: 'Budova',
  },
  buildingRequired: {
    id: 'app.common.buildingRequired',
    defaultMessage: 'Třeba vybrat budovu!',
  },
  outsideNotSpecified: {
    id: 'app.common.outsideNotSpecified',
    defaultMessage: 'Venku / Neupřesněno',
  },
  buildingPlaceholder: {
    id: 'app.common.buildingPlaceholder',
    defaultMessage: 'Budova 3B',
  },
  floor: {
    id: 'app.common.floor',
    defaultMessage: 'Podlaží',
  },
  floorPlaceholder: {
    id: 'app.common.floorPlaceholder',
    defaultMessage: 'Vyber podlaží',
  },
  QR: {
    id: 'app.common.QR',
    defaultMessage: 'QR kód',
  },
  scan: {
    id: 'app.common.scan',
    defaultMessage: 'Scan',
  },
  scanQR: {
    id: 'app.common.scanQR',
    defaultMessage: 'Naskenuj QR kód',
  },
  manufacturer: {
    id: 'app.common.manufacturer',
    defaultMessage: 'Výrobce',
  },
  meterModelLabel: {
    id: 'app.common.meterModelLabel',
    defaultMessage: 'Model měřidla',
  },
  manufacturedLabel: {
    id: 'app.Select.manufacturedLabel',
    defaultMessage: 'Rok výroby měřidla',
  },
  calibrated: {
    id: 'app.Select.calibratedLabel',
    defaultMessage: 'Rok cejchování měřidla',
  },
  meterOwnerType: {
    id: 'app.common.meterOwnerType',
    defaultMessage: 'Kategorie majitele',
  },
  meterOwnerTypeRequired: {
    id: 'app.common.meterOwnerTypeRequired',
    defaultMessage: 'Třeba vybrat kategorii majitele.',
  },
  meterOwnerTypePlaceholder: {
    id: 'app.common.meterOwnerTypePlaceholder',
    defaultMessage: 'Vyber kategorii majitele',
  },
  meterOwner: {
    id: 'app.common.meterOwner',
    defaultMessage: 'Majitel měřidla',
  },
  meterOwnerPlaceholder: {
    id: 'app.common.meterOwnerPlaceholder',
    defaultMessage: 'Napiš majitele měřidla',
  },
  internalSupplyPointCode: {
    id: 'app.common.internalSupplyPointCode',
    defaultMessage: 'Identifikace OM',
  },
  internalSupplyPointCodePlaceholder: {
    id: 'app.common.internalSupplyPointCodePlaceholder',
    defaultMessage: 'Napiš pomůcku pro napárování odběrného místa',
  },
  tenant: {
    id: 'app.common.tenant',
    defaultMessage: 'Nájemce',
  },
  note: {
    id: 'app.ServiceInspection.note',
    defaultMessage: 'Poznámka',
  },
  notePlaceholder: {
    id: 'app.ServiceInspection.notePlaceholder',
    defaultMessage: 'Je třeba speciálního vybavení! Nachází se ve stísněné šachtě!',
  },
});

export const LocationStepFooter = defineMessages({
  next: {
    id: 'app.common.next',
    defaultMessage: 'Další',
  },
});
